import React from 'react';
import Icon, { IconNames } from 'components/Input/Icon';
import TooltipControlled from 'components/Tooltip/tooltipControlled';
import styled from 'styled-components/macro';
import utils from 'utils';
import { breakpointsPalette, colorPalette } from 'utils/styleConstants';
import useMediaWidth from 'hooks/useMediaWidth';

const LegendaWrapper = styled.div`
  display: flex;
  align-items: center;
  label {
    font-size: ${({ theme }) => theme.fontSizePalette.small};
    color: ${({ theme }) => theme.colorPalette.grey.grey9};
  }
`;

const LegendaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const LegendaTitle = styled.label`
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
`;

export interface Item {
  icon?: IconNames;
  label: string;
  style?: React.CSSProperties;
}

export interface LegendaProps {
  items: Item[][];
  titles?: string[];
  withIcon?: boolean;
}

const LegendaContent = (props: LegendaProps) => {
  const t = utils.intl.useTranslator();
  const icons = props.items.map((line, i) => (
    <>
      {props.titles && props.titles[i] && line.length > 0 && (
        <div
          style={{
            marginBottom: 8,
          }}
        >
          <LegendaTitle>{t(props.titles[i])}</LegendaTitle>
          <LegendaWrapper key={i}>
            {line.map((item, index) => (
              <React.Fragment key={index}>
                <Icon icon={item.icon} style={{ width: 11, margin: 7, display: 'inline', ...item.style }} />
                <label>{t(item.label)}</label>
              </React.Fragment>
            ))}
          </LegendaWrapper>
        </div>
      )}
    </>
  ));
  return <LegendaContainer>{icons}</LegendaContainer>;
};

const Legenda = (props: LegendaProps) => {
  const width = useMediaWidth();
  return (
    <>
      {props.withIcon ? (
        <TooltipControlled
          content={<LegendaContent {...props} />}
          placement={width > Number(breakpointsPalette.m.replace('px', '')) ? 'bottom' : 'right'}
        >
          <Icon
            icon={'tooltip-filled'}
            style={{ cursor: 'pointer', color: `${colorPalette.grey.grey5}` }}
            label="Legend"
          />
        </TooltipControlled>
      ) : (
        <>{<LegendaContent {...props} />}</>
      )}
    </>
  );
};

export default Legenda;
